import { FC } from "react";

import { AUTH_LINK_CLASSNAME } from "./constants";

export const TermsAndConditionsNotice: FC = () => (
  <div className="mb-4 text-xs dark:text-stone-300 ">
    By creating an account, you agree to vviinn's{" "}
    <a
      href="https://www.vviinn.com/policy"
      className={`${AUTH_LINK_CLASSNAME} dark:text-stone-400`}
      target="_blank"
      rel="noreferrer"
    >
      Conditions of Use
    </a>
    .
  </div>
);
